export const LOCAL_STORAGE_KEYS = {
  CURRENT_ORGANISATION: 'infpl.current.organisation.v1',
  PLANNEN_FILTERS: 'plannen.filters.v1',
  AFSTEMMINGSDOSSIERS_FILTERS: 'afstemmingsdossiers.filters.v1',
  BERICHTENCENTRUM_FILTERS: 'berichtencentrum.filters.v1',
} as const;

// Deze keys worden gereset zodra de actieve organisatie wijzigt.
export const ORGANISATIE_SWITCH_RESET_KEYS: string[] = [
  LOCAL_STORAGE_KEYS.PLANNEN_FILTERS,
  LOCAL_STORAGE_KEYS.AFSTEMMINGSDOSSIERS_FILTERS,
  LOCAL_STORAGE_KEYS.BERICHTENCENTRUM_FILTERS,
];
